"use client";
import Image from "next/image";
import HeadingSize from "../ui/HeadingSize";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import ResponsivePicture from "../ui/ResponsivePicture";

interface TestimonialProps {
  name: string;
  location: string;
  title: string;
  description: string;
  image: string;
}

function TestimonialCard({
  name,
  location,
  title,
  description,
  image,
}: TestimonialProps) {
  return (
    <div className=" w-[260px] md:w-[360px]">
      <div className=" w-[260px] md:w-[360px] bg-[#f8f6f9] rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-sm min-h-[320px] sm:min-h-[380px] md:min-h-[420px] flex flex-col">
        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
          <ResponsivePicture
            baseSrc={image}
            alt={name}
            width={80}
            height={80}
            className="w-[45px] h-[45px] sm:w-[50px] sm:h-[50px] md:w-[80px] md:h-[80px] rounded-full"
          />
          <div>
            <h3 className="font-bold text-sm sm:text-base text-[#971d1d]">
              {name}
            </h3>
            <p className="text-sm font-semibold sm:text-base text-[#971d1d]">
              {location}
            </p>
          </div>
        </div>
        <h4 className="font-semibold text-[20px] mb-2 sm:mb-3 md:mb-4 h-[60px] sm:h-[72px] md:h-[84px] line-clamp-2 flex items-center text-[#000000]">
          {title.split("<br/>").map((part, i) => {
            // Create a stable key without using index
            const stableKey = `title-part-${part}`;
            return (
              <Fragment key={stableKey}>
                {i > 0 && <br />}
                {part}
              </Fragment>
            );
          })}
        </h4>
        <p className="text-base sm:text-lg md:text-[18px] text-[#4c4c4c] leading-relaxed h-[96px] sm:h-[120px] md:h-[144px] font-semibold">
          {description}
        </p>
      </div>
    </div>
  );
}

export default function TrustedFacesSection() {
  const { t } = useTranslation();

  const testimonials: TestimonialProps[] = [
    {
      name: t("home.testimonials.neelabh.name"),
      location: t("home.testimonials.neelabh.location"),
      title: t("home.testimonials.neelabh.title"),
      description: t("home.testimonials.neelabh.description"),
      image: "/images/Testimonial/Neelabh-Sangal",
    },
    {
      name: t("home.testimonials.rais.name"),
      location: t("home.testimonials.rais.location"),
      title: t("home.testimonials.rais.title"),
      description: t("home.testimonials.rais.description"),
      image: "/images/Testimonial/Rais-Khan",
    },
    {
      name: t("home.testimonials.aman.name"),
      location: t("home.testimonials.aman.location"),
      title: t("home.testimonials.aman.title"),
      description: t("home.testimonials.aman.description"),
      image: "/images/Testimonial/Aman-Rana",
    },
  ];
  return (
    <section className="py-10 md:py-12  lg:py-16 mx-auto bg-white ">
      <div className=" px-2 sm:px-4 md:px-6 lg:px-8">
        <div className=" text-center mb-8 sm:mb-12 md:mb-16 tracking-normal">
          <HeadingSize text={t("home.customerReviews")} />
        </div>

        <div className="flex flex-row items-center gap-5 justify-between overflow-x-auto pb-4  scrollbar-hide max-w-7xl mx-auto">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.name} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}
